import React from "react";

class CoverPage extends React.Component{

    render() {
        return (
            <div>
                Otulina
            </div>
        )
    }
}

export default CoverPage;